import { Injectable } from '@angular/core';
import * as Bowser from 'bowser';

@Injectable()
export class BrowserSupportedService {

    isSupported(): boolean {
        const browser = Bowser.getParser(window.navigator.userAgent);
        return browser.satisfies({
            chrome: '>=60',
            chromium: '>=60',
            firefox: '>=58',
            edge: '>=16',
            safari: '>=10'
        });
    }
}
